<template>
    <b-modal :id="id" v-model="modalShow" :size="size" :title="title">
        <template #modal-title v-if="!title">
            <portal-target name="modal-title"></portal-target>
        </template>
        <b-overlay
            :show="loading && loading_id == id"
            rounded="sm"
            :opacity="opacity"
        >
            <slot></slot>
            <template #overlay>
                <div class="text-center">
                    <loading />
                </div>
            </template>
        </b-overlay>

        <template #modal-footer>
            <div class="w-100">
                <b-button
                    variant="outline-secondary"
                    class="float-right"
                    @click="modalShow = false"
                >
                    Fechar
                </b-button>
                <b-button
                    type="submit"
                    v-if="btn_save"
                    :form="form"
                    class="float-right"
                    :disabled="loading_btn"
                    variant="outline-secondary"
                    ><span v-if="!loading_btn" v-html="btn_save_name"></span>
                    <span v-else>
                        <b-spinner small></b-spinner>
                        Processando...
                    </span>
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    name: "Modal",
    props: {
        size: { type: String, default: "xl" },
        id: { required: true },
        form: String,
        btn_save: Boolean,
        btn_save_name: {
            type: String,
            default: "<i class='fas fa-save'></i> Salvar"
        },
        title: String
    },
    data() {
        return {
            modalShow: false,
            opacity: 0.45
        };
    },
    watch: {
        id() {
            this.setLoadId(this.id);
        },
        modalShow(newValue, oldValue) {
            if (newValue) this.setLoadId(this.id);

            if (!newValue) {
                this.setCurrentModal(null);
                if (this.getComponent("Modal")) {
                    this.setLoadId(this.getComponent("Modal")._props.id);
                }
            }
        }
    },
    created() {
        if (this.modalShow) this.setLoadId(this.id);
    },
    computed: {
        ...mapState("loading", ["loading", "loading_id", "loading_btn"])
    },
    methods: {
        ...mapMutations("loading", ["statusBtn", "setLoadId"]),
        ...mapMutations("modal", ["setCurrentModal"]),

        setCurrentLoading() {
            this.setLoadId(this.id);
        },
        getComponent(componentName) {
            let component = null;
            let parent = this.$parent;
            while (parent && !component) {
                if (parent.$options.name === componentName) {
                    component = parent;
                }
                parent = parent.$parent;
            }
            return component;
        }
    }
};
</script>
